export const uk = {
    'archived-campaign-modification': 'Нельзя добавлять фразы в архивные кампании',
    'max-keywords-exceeded': 'Превышено максимальное ограничение в {maxKeywords} фраз на группу',
    'validation-error': 'Не удалось добавить фразы к группе. Попробуйте позже'
};
